// extracted by mini-css-extract-plugin
module.exports = {"logos":"Logos_logos__DjbHn","logo":"Logos_logo__PmV8h"};